module.exports = __webpack_public_path__ + "img/videoPoster3.c56144bc.jpg";